import Repository from "../Repository";

const resource = "/attachments";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getAttachment(attachmentId){
        return Repository.get(`${resource}/${attachmentId}`);
    },
    createAttachment(json){
        return Repository.post(`${resource}`,json);
    },
    updateAttachment(attachmentId,json){
        return Repository.put(`${resource}/${attachmentId}`,json);
    },
    deleteAttachment(attachmentId){
        return Repository.delete(`${resource}/${attachmentId}`);
    }
}